import React from 'react';
import { FormikProps, withFormik } from 'formik';

import { emailSchema } from '@/services/validators/email';
import { SetCapyValues } from '@/components/shared/CapyCaptcha';
import { FormContents, Values } from './FormContents';

export type { Values } from './FormContents';

type OuterProps = {
  initialEmail: string;
  isLoading: boolean;
  onSubmit: (values: Values) => void;
  setCapyValues: SetCapyValues;
  capyError: boolean;
};

export const ActivationStart = withFormik<OuterProps, Values>({
  mapPropsToValues: ({ initialEmail }) => ({
    email: initialEmail,
    ignoreCapyCaptcha: false,
  }),
  validationSchema: emailSchema,
  handleSubmit: (values, { props, setSubmitting }) => {
    props.onSubmit(values);
    setSubmitting(false);
  },
})(
  // enhanced form
  ({
    errors,
    handleChange,
    handleSubmit,
    isLoading = false,
    touched,
    values,
    capyError,
    setCapyValues,
  }: OuterProps & FormikProps<Values>) => {
    return (
      <FormContents
        errors={errors}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
        touched={touched}
        values={values}
        capyError={capyError}
        setCapyValues={setCapyValues}
      />
    );
  },
);
